
export function createApplicantDocument(applicantId, clientId, docInfo, done) {
  return simpleIsoFetch => () => {

    simpleIsoFetch.post({
        route: `/api/applicants/${applicantId}/documents/${clientId}`,
        body : docInfo
      })
      .then(({body: {data: {items: [id]}}}) => id)
      .then(id => done(null, id))
      .catch(done)
    ;

  };

}


export function deleteApplicantDocument(applicantId, clientId, done) {
  return simpleIsoFetch => () => {

    simpleIsoFetch.del(`/api/applicants/${applicantId}/documents/${clientId}`)
      .then(() => done(null))
      .catch(done)
    ;

  }
}



// WEBPACK FOOTER //
// ./shared/redux/actionCreators/async/documents.js